import * as Yup from 'yup'

export const WebsiteValidationSchema = Yup.object({
  name: Yup.string().required(),
  url: Yup.string().required().url(),
  endpoint: Yup.string().required(),
  smsShortName: Yup.string().required(),
  enabled: Yup.bool()
})